import React, {
    createRef,
    useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import paginationFactoryImport from 'react-bootstrap-table2-paginator'
import BootstrapTableImport from 'react-bootstrap-table-next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ColumnDescription } from 'react-bootstrap-table-next'
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
} from 'reactstrap'

import { useAppSelector } from '../../../hooks/redux'
import {
    deleteCompany,
    readCompanies,
    Company,
} from './helpers'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BootstrapTable = (BootstrapTableImport as any).default || BootstrapTableImport
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const paginationFactory = (paginationFactoryImport as any).default || paginationFactoryImport

interface RowActionsDropdownProps {
    children: React.ReactNode
}

const RowActionsDropdown = ({ children }: RowActionsDropdownProps) => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(open => !open)}>
            {children}
        </Dropdown>
    )
}

interface CompaniesTableProps {
    editCompany: (company: Company | null, modalOpen?: boolean) => void
}

/**
 * Table listing all companies with edit and delete actions.
 */
const CompaniesTable = ({ editCompany }: CompaniesTableProps) => {
    const table = createRef()

    const companies = useAppSelector(state => state.superAdmin.companies) as Company[]
    const { t } = useTranslation()

    const actionFormatter = (_column: unknown, company: Company) => {
        return (
            <RowActionsDropdown>
                <DropdownToggle color="link" size="sm" className="text-600 btn-reveal mr-3">
                    <FontAwesomeIcon icon="ellipsis-h" className="fs--1" />
                </DropdownToggle>
                <DropdownMenu positionFixed={true} right className="border py-2">
                    <DropdownItem onClick={() => window.swconfirm({
                        title: t('company.deleteCompanyPrompt', { companyName: company.name }),
                        onConfirm: () => deleteCompany(company).then(readCompanies),
                    })}>
                        {t('company.deleteCompany')}
                    </DropdownItem>
                    <DropdownItem
                        onClick={() => editCompany(company, true)}
                    >
                        {t('company.editCompany')}
                    </DropdownItem>
                </DropdownMenu>
            </RowActionsDropdown>
        )
    }

    const columns: ColumnDescription<Company>[] = [
        {
            dataField: 'name',
            text: 'Jméno',
            classes: 'border-0 align-middle text-900 ',
            headerClasses: 'border-0',
            sort: true,
        },
        {
            dataField: 'uid',
            text: '',
            isDummyField: true,
            classes: 'py-2 align-middle',
            formatter: actionFormatter,
            align: 'right',
        },
    ]

    const options = {
        paginationSize: 3,
        pageStartIndex: 1,
        sizePerPage: 10,
        totalSize: companies.length,
        hidePageListOnlyOnePage: true,
        prePageText: '<',
        nextPageText: '>',
        hideSizePerPage: true,
        showTotal: false,
    }

    return (
        <BootstrapTable
            ref={table}
            bootstrap4
            keyField='uid'
            data={companies}
            columns={columns}
            bordered={false}
            classes='table-dashboard table-striped table-sm fs--1 border-bottom border-200 mb-0 table-dashboard-th-nowrap text-black'
            rowClasses='btn-reveal-trigger border-top border-200'
            headerClasses='bg-200 text-900 border-y border-200'
            pagination={companies.length > 10 ? paginationFactory(options) : null}
        />
    )
}

export default CompaniesTable
